// ISMS 웹 클라 공용 상수 — actions/reducers/ismsClient 가 함께 import (순환 import 방지용으로 의존 0)
// 서버 계약: sales-server docs/isms/endpoints.md (2026-09-14)
export const ISMS_STATUS_RECEIVED = "ISMS_STATUS_RECEIVED";
export const ISMS_LOCKED = "ISMS_LOCKED";
export const ISMS_UNLOCKED = "ISMS_UNLOCKED";
export const ISMS_BLOCKED = "ISMS_BLOCKED";
export const ISMS_IDLE_WARNING = "ISMS_IDLE_WARNING";
export const ISMS_OTP_REQUIRED = "ISMS_OTP_REQUIRED";
export const ISMS_OTP_UPDATED = "ISMS_OTP_UPDATED";
export const ISMS_OTP_DONE = "ISMS_OTP_DONE";
export const ISMS_RESET = "ISMS_RESET";

export const ISMS_ERROR_RE = /^\[(ISMS_[A-Z_]+)\]\s*(.*)$/;
export const LOCK_MESSAGES = {
  IDLE: "장시간 미사용으로 세션이 잠겼습니다. 다시 로그인해 주세요.",
  RELOGIN_REQUIRED: "보안 정책이 갱신되어 다시 로그인해 주세요.",
  SUPERSEDED: "다른 기기에서 로그인되어 이 세션이 종료되었습니다.",
  ADMIN: "관리자에 의해 세션이 잠겼습니다. 다시 로그인해 주세요.",
};
export const TRUSTED_DEVICE_COOKIE = "gs_td";
